export function facebookPageAvatarUrl(page) {
  const fromGraph =
    page?.picture?.data?.url || page?.picture?.url || page?.picture;
  if (fromGraph && typeof fromGraph === 'string') return fromGraph;

  const id = page?.id || page?.page_id;
  return id ? `https://graph.facebook.com/${id}/picture?type=normal` : '';
}
